var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#38AEC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 40.25H38.625V34.0625C38.625 33.7517 38.3733 33.5 38.0625 33.5H37.1077C36.7744 33.5 36.4488 33.5984 36.1718 33.7834L35.0939 34.502C35.0324 34.5429 34.9796 34.5955 34.9385 34.6569C34.8974 34.7182 34.8688 34.7871 34.8543 34.8595C34.8398 34.9319 34.8397 35.0065 34.854 35.0789C34.8684 35.1514 34.8968 35.2203 34.9378 35.2817L35.5622 36.2176C35.6031 36.2791 35.6558 36.3319 35.7171 36.373C35.7785 36.4141 35.8473 36.4427 35.9197 36.4572C35.9921 36.4717 36.0667 36.4718 36.1392 36.4575C36.2116 36.4431 36.2805 36.4147 36.342 36.3737L36.375 36.3519V40.25H35.25C34.9392 40.25 34.6875 40.5017 34.6875 40.8125V41.9375C34.6875 42.2483 34.9392 42.5 35.25 42.5H39.75C40.0608 42.5 40.3125 42.2483 40.3125 41.9375V40.8125C40.3125 40.5017 40.0608 40.25 39.75 40.25ZM57.75 24.5H17.25C16.0076 24.5 15 25.5076 15 26.75V49.25C15 50.4924 16.0076 51.5 17.25 51.5H57.75C58.9924 51.5 60 50.4924 60 49.25V26.75C60 25.5076 58.9924 24.5 57.75 24.5ZM18.375 48.125V43.625C20.8605 43.625 22.875 45.6395 22.875 48.125H18.375ZM18.375 32.375V27.875H22.875C22.875 30.3605 20.8605 32.375 18.375 32.375ZM37.5 45.875C33.772 45.875 30.75 42.3488 30.75 38C30.75 33.6505 33.772 30.125 37.5 30.125C41.228 30.125 44.25 33.6505 44.25 38C44.25 42.3502 41.2266 45.875 37.5 45.875ZM56.625 48.125H52.125C52.125 45.6395 54.1395 43.625 56.625 43.625V48.125ZM56.625 32.375C54.1395 32.375 52.125 30.3605 52.125 27.875H56.625V32.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCircle);
export default __webpack_public_path__ + "static/media/billing_circle.fd4de64af4168047601b2ad11859bb74.svg";
export { ForwardRef as ReactComponent };